import React, { useEffect } from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import RenewalFormsHeader from 'components/web-forms-list/RenewalFormsHeader';
import { useLazyQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { USER_ACTIONS } from 'types/enrollmentService';
import WebFormsTable, { EmployerFormInstance } from 'components/web-forms-list/WebFormsTable';
import { GET_RENEWAL_FORM_INSTANCES } from 'api/queries/formService';
import { createStyles } from '../../globalStyles';

const RenewalFormsPage = (): JSX.Element => {
  const classes = createStyles();

  const { periodId } = useParams<{ periodId: string }>();

  const [getWebFormInstances, { data, loading }] = useLazyQuery<{
    getRenewalFormInstances: EmployerFormInstance[];
  }>(GET_RENEWAL_FORM_INSTANCES, {
    fetchPolicy: 'no-cache',
    variables: {
      enrollmentPeriodId: periodId,
    },
  });

  // Effects
  useEffect(() => {
    void getWebFormInstances();
  }, []);

  return (
    <ProposalStatusLayout>
      <div className={classes.pageWrapper}>
        <RenewalFormsHeader />
        <WebFormsTable
          formInstances={data?.getRenewalFormInstances || []}
          loading={loading}
          userAction={USER_ACTIONS.COMPLETE_RENEWAL_FORMS}
          redirectLink="renewal-form"
        />
      </div>
    </ProposalStatusLayout>
  );
};

export default RenewalFormsPage;
